// Some starter smooth scrolling JS
// Uses jQuery animate() method - https://api.jquery.com/animate/
(function($) {
	// Add smooth scrolling to all links
	$("a").not('.open-popup-link, .gform_button').on('click', function(event) {

		//Exclude anchors inside p.open-popup-link
		let parent = $(this).parent();
		if (parent.hasClass('open-popup-link')) {
			return;
		}

		// Check for query params and run ajax query if they exist
		if (this.search !== '' && $('#filter-form').length > 0) {
			console.log($('#filter-form').length);
			// store params
			const paramString = new URLSearchParams(this.search);

			// update filter form 
			for( let p of paramString) {

				// get correct filter form field
				var formField = '#filter-form [name=' + p[0] + ']';

				// check if option exists
				var optionSelect = $(formField + ' [value=' + p[1] + ']');
				if (optionSelect.length > 0) {
					console.log(true);
					// if option exists, change to the value
					$(formField).val(p[1]).change();
				}
				else {
					console.log(false);
					// select the default
					$(formField).prop("selectedIndex", 0).change();
				}
			}

			// Add query string to URL
			history.pushState(null, window.title, this.search);			
		}


		// Make sure this.hash has a value before overriding default behavior
		if (this.hash !== '' && this.hash != '#search') {
			// Store hash
			var hash = this.hash;

			//only intercept if the hash is on the page
			if (!$(hash).length) return;

			// Prevent default anchor click behavior
			event.preventDefault();
			// headerHeight = $("header.site-header").height(); // Get fixed header height

			// Using jQuery's animate() method to add smooth page scroll
			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			$('html, body').animate({
				scrollTop: $(hash).offset().top - '80'
			}, 800, function() {

				// Add hash (#) to URL when done scrolling (default click behavior)
				//window.location.hash = hash;
				history.pushState(null, window.title, window.location.href.split('#')[0]+hash);

			});
		} // End if			
	});

	if(window.location.hash && $(window.location.hash).length) {
		// smooth scroll to the anchor id
		// event.preventDefault();
		// headerHeight = $("header.site-header").height(); // Get fixed header height

		$('html, body').animate({
			scrollTop: $(window.location.hash).offset().top
		}, 800);
	}
})(jQuery);
